var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesReturnCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1667 59.5833C41.1667 63.7867 44.4167 67.1667 48.4034 67.1667H56.55C60.0166 67.1667 62.8333 64.22 62.8333 60.5367C62.8333 56.5934 61.1 55.1634 58.5434 54.2534L45.5 49.7034C42.9433 48.7934 41.21 47.4067 41.21 43.42C41.21 39.78 44.0266 36.79 47.4933 36.79H55.64C59.6267 36.79 62.8767 40.17 62.8767 44.3734",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 32.5V71.5",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3333 52C95.3333 75.92 75.92 95.3333 52 95.3333C28.08 95.3333 8.66667 75.92 8.66667 52C8.66667 28.08 28.08 8.66666 52 8.66666",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3333 26V8.66666H78",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6667 30.3333L95.3333 8.66666",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesReturnCard);
export default __webpack_public_path__ + "static/media/sales-return-card.401b14c13f9db4855f7e5be1d9efb74e.svg";
export { ForwardRef as ReactComponent };